import {Grid, makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import React, {useContext} from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import TableHeader from '../../../components/table/TableHeader';
import {Skeleton} from '@material-ui/lab';
import TablePagination from '../../../components/table/Pagination';
import {InstalmentPlanListDataContext} from '../InstalmentPlanListDataContext';
import InstalmentPlanRow from './InstalmentPlanRow';

type InstalmentPlansTableProps = {
  showPagination: Boolean;
};

const useStyles = makeStyles((theme) => ({
  skeleton: {
    height: '200px',
  },
  main: {
    padding: theme.spacing(1),
  },
}));

const InstalmentPlansTable = ({ showPagination }: InstalmentPlansTableProps) => {
  const { t } = useTranslation('instalmentPlans');

  const classes = useStyles();

  const context = useContext(InstalmentPlanListDataContext);

  const preColumns = !context.isPrefilteredForCustomer
    ? [
        {
          label: t('status'),
          id: 'status',
        },
        {
          label: t('customer'),
          id: 'debitor',
        },
      ]
    : [
        {
          label: t('status'),
          id: 'status',
        },
      ];

  const columns = preColumns.concat([
    {
      label: t('purpose'),
      id: 'purpose',
    },
    {
      label: t('total amount'),
      id: 'amount',
    },
    {
      label: t('duration'),
      id: 'duration',
    },
    {
      label: t('rate'),
      id: 'rate',
    },
    {
      label: t('open amount'),
      id: 'open_amount',
    },
    {
      label: t('next payment date'),
      id: 'next payment date',
    },
    {
      label: t('creationDate'),
      id: 'createdDateTime',
    },
  ]);

  const initalLoad = !context.page && context.loading;
  const emptyResultList = !!context.page && context.instalmentPlans.length === 0;
  const emptyFilteredResultList = emptyResultList && context.filters?.used;

  return (
    <>
      {emptyResultList ? (
        <>
          {emptyFilteredResultList ? (
            <Typography style={{ marginTop: '40px' }}>{t('no results for your search')}</Typography>
          ) : (
            <Grid item xs={12} className={classes.main}>
              <MuiAlert elevation={6} variant="filled" severity="warning">
                {t('no instalment plans yet')}
              </MuiAlert>
            </Grid>
          )}
        </>
      ) : (
        <>
          <TableContainer style={{ flex: '1 1 auto' }}>
            <Table>
              <TableHeader columns={columns} actions={true}></TableHeader>
              <TableBody>
                <>
                  {initalLoad && (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1}>
                        <Skeleton className={classes.skeleton} />
                      </TableCell>
                    </TableRow>
                  )}
                  {context.instalmentPlans?.map((instalmentPlan, index) => (
                    <InstalmentPlanRow instalmentPlan={instalmentPlan} index={index} key={instalmentPlan.id}></InstalmentPlanRow>
                  ))}
                </>
              </TableBody>
            </Table>
          </TableContainer>
          {showPagination && <TablePagination transformPageSizeLabel={(pageSize) => t('pageSize', { pageSize: pageSize }) as string} />}
        </>
      )}
    </>
  );
};

export default InstalmentPlansTable;
